import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, normalizeClass as _normalizeClass, createVNode as _createVNode, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "tw-p-10 tw-flex tw-flex-col tw-gap-[25px]" }
const _hoisted_2 = /*#__PURE__*/_createElementVNode("div", { class: "tw-text-[15px] tw-flex tw-flex-col tw-gap-[10px]" }, [
  /*#__PURE__*/_createElementVNode("div", { class: "tw-font-semibold tw-text-[#211F58]" }, " Lorem ipsum dolor sit amet consectetur. "),
  /*#__PURE__*/_createElementVNode("div", { class: "tw-font-normal" }, " Lorem ipsum dolor sit amet consectetur. Leo amet tincidunt ut quisque ut. A sit porttitor nibh sem rhoncus donec. Volutpat eget mi arcu egestas amet dictumst dignissim. Molestie id semper morbi libero maecenas. ")
], -1)
const _hoisted_3 = /*#__PURE__*/_createElementVNode("div", { class: "tw-text-[15px] tw-flex tw-flex-col tw-gap-[10px]" }, [
  /*#__PURE__*/_createElementVNode("div", { class: "tw-font-semibold tw-text-[#211F58]" }, " Lorem ipsum dolor sit amet consectetur. "),
  /*#__PURE__*/_createElementVNode("div", { class: "tw-font-normal" }, " Lorem ipsum dolor sit amet consectetur. Leo amet tincidunt ut quisque ut. A sit porttitor nibh sem rhoncus donec. Volutpat eget mi arcu egestas amet dictumst dignissim. Molestie id semper morbi libero maecenas. ")
], -1)
const _hoisted_4 = /*#__PURE__*/_createElementVNode("div", { class: "tw-text-[15px] tw-flex tw-flex-col tw-gap-[10px]" }, [
  /*#__PURE__*/_createElementVNode("div", { class: "tw-font-semibold tw-text-[#211F58]" }, " Lorem ipsum dolor sit amet consectetur. "),
  /*#__PURE__*/_createElementVNode("div", { class: "tw-font-normal" }, " Lorem ipsum dolor sit amet consectetur. Leo amet tincidunt ut quisque ut. A sit porttitor nibh sem rhoncus donec. Volutpat eget mi arcu egestas amet dictumst dignissim. Molestie id semper morbi libero maecenas. ")
], -1)
const _hoisted_5 = { class: "tw-text-right" }

import ModalHeader from "@/components/common/modalHeader.vue";
import { getComponentUiText } from "@/utils/utilities";
import { ref, watch } from "vue";
import ModalComponent from "../common/modalComponent.vue";


export default /*#__PURE__*/_defineComponent({
  __name: 'moreInfoModal',
  props: {
  isMoreInfoModal: {
    type: Boolean,
    required: true,
  },
},
  emits: ["update:show"],
  setup(__props, { emit }) {

const props = __props;



let showRef = ref(props.isMoreInfoModal);
let notInfoVisible = ref(true);

watch(
  () => props.isMoreInfoModal,
  (value) => {
    showRef.value = value;
    if (value) notInfoVisible.value = true;
  },
);


const handleCloseModal = () => {
  showRef.value = false;
  emit("update:show", showRef.value);
};

const styleClassContain = {
  "border-radius": "4px",
  "box-shadow": "0px 0px 4px 0px rgba(0, 0, 0, 0.05)",
};

return (_ctx: any,_cache: any) => {
  const _component_b_button = _resolveComponent("b-button")!

  return (_openBlock(), _createBlock(ModalComponent, {
    "model-value": _unref(showRef),
    close: handleCloseModal,
    "max-width": 60.0625,
    "style-class-contain": styleClassContain
  }, {
    default: _withCtx(() => [
      _createVNode(ModalHeader, {
        style: {"z-index":"10"},
        class: _normalizeClass(`modal-header`),
        title: _unref(getComponentUiText)('app-more-info-modal-title-1'),
        onClose: handleCloseModal
      }, null, 8, ["title"]),
      _createElementVNode("div", _hoisted_1, [
        _hoisted_2,
        _hoisted_3,
        _hoisted_4,
        _createElementVNode("div", _hoisted_5, [
          _createVNode(_component_b_button, {
            variant: "primary",
            class: "tw-w-fit tw-shadow-none tw-bg-[#387DFF] tw-py-[7px] tw-px-[20px] tw-text-[13px] tw-font-medium tw-rounded-[27px]",
            type: "submit",
            onClick: handleCloseModal
          }, {
            default: _withCtx(() => [
              _createTextVNode(" Close ")
            ]),
            _: 1
          })
        ])
      ])
    ]),
    _: 1
  }, 8, ["model-value"]))
}
}

})